/** Decide the landing screen before mounting dashboard navigation or queries. */
export function resolveDashboardEntry(state: {
  pathname: string;
  loading: boolean;
  error: unknown;
  complete: boolean;
  welcomeSeen: boolean;
}): 'loading' | 'welcome' | 'dashboard' {
  if (state.loading) return 'loading';
  if (state.pathname === '/' && !state.error && !state.complete && !state.welcomeSeen) return 'welcome';
  return 'dashboard';
}
